import {
    trackPromptOpen,
    trackPromptClose,
    trackPromptSignIn,
    trackPromptRegister
} from './AuthPrompts.tracking';
import { Prompts } from './AuthPrompts.types';
import { consentNotShownInLastTenMins } from './utils/consentNotShownInLastTenMins';

export const GENERAL_PROMPT_EXPERIMENT =
    'crme_1088_lsrp_sign_in_general_prompt';

export const LDP_PROMPT_EXPERIMENT =
    'crme_1093_ldp_sign_in_save_listing_prompt';

export const PDP_PROMPT_EXPERIMENT =
    'crme_1094_pdp_sign_in_save_property_prompt';

export const LSRP_PROMPT_VARIANTS = 'crme_1092_lsrp_sign_in_alerts_prompt';

export const LSRP_DELAY_PROMPT_EXPERIMENT =
    'crme_1145_lsrp_sign_in_get_instant_alerts_prompt';

export const AA_PROMPT_EXPERIMENT = 'reg_profile_a_a_sign_in_test';

export const PROMPTS: Prompts = {
    generic: {
        experimentName: GENERAL_PROMPT_EXPERIMENT,
        title: "Like what you see? You can save it when you're signed in",
        tracking: {
            trackOpen: trackPromptOpen,
            trackClose: trackPromptClose,
            trackSignIn: trackPromptSignIn,
            trackRegister: trackPromptRegister
        },
        condition: (isMobile, isLoggedOut, consentCookie) => {
            return (
                isMobile &&
                isLoggedOut &&
                consentNotShownInLastTenMins(consentCookie)
            );
        }
    },
    ldpSaveListing: {
        experimentName: LDP_PROMPT_EXPERIMENT,
        title: "Like what you see? You can save it when you're signed in",
        tracking: {
            trackOpen: trackPromptOpen,
            trackClose: trackPromptClose,
            trackSignIn: trackPromptSignIn,
            trackRegister: trackPromptRegister
        },
        condition: (isMobile, isLoggedOut, consentCookie, variation) => {
            return (
                isMobile &&
                isLoggedOut &&
                sessionStorage.getItem('authPromptClose') === null &&
                consentNotShownInLastTenMins(consentCookie) &&
                variation !== 'control'
            );
        },
        delayCondition: {
            prompt_launch: {
                time: 0
            },
            prompt_delayed: {
                time: 15
            }
        }
    },
    pdpTrackProperty: {
        experimentName: PDP_PROMPT_EXPERIMENT,
        title:
            'Interested? Track this home’s value when you sign in or register.',
        tracking: {
            trackOpen: trackPromptOpen,
            trackClose: trackPromptClose,
            trackSignIn: trackPromptSignIn,
            trackRegister: trackPromptRegister
        },
        condition: (isMobile, isLoggedOut, consentCookie, variation) => {
            return (
                isMobile &&
                isLoggedOut &&
                sessionStorage.getItem('authPromptClose') === null &&
                consentNotShownInLastTenMins(consentCookie) &&
                variation !== 'control'
            );
        },
        delayCondition: {
            prompt_launch: {
                time: 0
            },
            prompt_delay: {
                time: 20
            }
        }
    },
    lsrpSavePropertyDelayPrompt: {
        experimentName: LSRP_DELAY_PROMPT_EXPERIMENT,
        title: 'Get instant alerts when new properties become available',
        tracking: {
            trackOpen: trackPromptOpen,
            trackClose: trackPromptClose,
            trackSignIn: trackPromptSignIn,
            trackRegister: trackPromptRegister
        },
        condition: (isMobile, isLoggedOut, consentCookie, variation) => {
            return (
                isMobile &&
                isLoggedOut &&
                sessionStorage.getItem('authPromptClose') === null &&
                consentNotShownInLastTenMins(consentCookie) &&
                variation !== 'control'
            );
        },
        delayCondition: {
            prompt_launch: {
                time: 0
            },
            prompt_delay: {
                time: 9
            }
        }
    },
    lsrpMessagesVariants: {
        experimentName: LSRP_PROMPT_VARIANTS,
        title: {
            get_instant:
                'Get instant alerts when new properties become available',
            know_exactly: 'Know exactly what you’re looking for?',
            save_properties:
                'Save properties and keep all your favourites in one place'
        },
        subtitle: {
            know_exactly:
                'Get instant alerts for homes that match what you’re looking for.'
        },
        tracking: {
            trackOpen: trackPromptOpen,
            trackClose: trackPromptClose,
            trackSignIn: trackPromptSignIn,
            trackRegister: trackPromptRegister
        },
        condition: (isMobile, isLoggedOut, consentCookie, variation) => {
            return (
                isMobile &&
                isLoggedOut &&
                sessionStorage.getItem('authPromptClose') === null &&
                consentNotShownInLastTenMins(consentCookie) &&
                variation !== 'control'
            );
        }
    },
    aaExperiment: {
        experimentName: AA_PROMPT_EXPERIMENT,
        title:
            'Interested? Track this home’s value when you sign in or register.',
        tracking: {
            trackOpen: trackPromptOpen,
            trackClose: trackPromptClose,
            trackSignIn: trackPromptSignIn,
            trackRegister: trackPromptRegister
        },
        condition: (isMobile, isLoggedOut, consentCookie, variation) => {
            return (
                isMobile &&
                isLoggedOut &&
                sessionStorage.getItem('authPromptClose') === null &&
                consentNotShownInLastTenMins(consentCookie) &&
                variation !== 'control'
            );
        },
        delayCondition: {
            prompt_launch: {
                time: 0
            },
            prompt_delay: {
                time: 20
            }
        }
    }
};

export const PROMPT_EXPERIMENT_BREAKPOINT = 768;

export const CONSENT_COOKIE = 'cookie_consents';
